import React from "react";

const DeliverySettings = ({ deliveryData }) => {
  return (
    <>
 
    <div className="space-y-4 montserrat-font-1">
      {deliveryData?.charges?.map((charge, i) => (
        <div
          key={i}
          className="bg-white border rounded-xl p-6 shadow-sm"
        >
          {/* Header */}
          <h2 className="text-green-700 font-semibold text-lg mb-4">
            Currently Applied Delivery Charges
          </h2>

          {/* Body */}
          <div className="border-t pt-4 space-y-3 text-sm">
            <div className="flex justify-between">
              <span className="text-gray-600">Charges:</span>
              <span className="font-medium text-gray-800">
                {charge.charge_type === "fixed" ? "₹" : ""}
                {parseFloat(charge.charges || 0).toFixed(2)}
                {charge.charge_type === "percentage" ? "%" : ""}
              </span>
            </div>

            <div className="flex justify-between">
              <span className="text-gray-600">Type:</span>
              <span className="font-medium text-gray-800 capitalize">
                {charge.charge_type}
              </span>
            </div>

            <div className="flex justify-between">
              <span className="text-gray-600">From:</span>
              <span className="font-medium text-gray-800">
                ₹{parseFloat(charge.from_amt || 0).toFixed(2)}
              </span>
            </div>

            <div className="flex justify-between">
              <span className="text-gray-600">To:</span>
              <span className="font-medium text-gray-800">
                ₹{parseFloat(charge.to_amt || 0).toFixed(2)}
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
    </>
  );
};

export default DeliverySettings;